<!--<ul class="navbar-nav">
  <li>
    <div class="dropdown" ngbDropdown placement="auto">
      <a ngbDropdownToggle href="javascript:" data-toggle="dropdown"><i class="icon feather icon-bell"></i></a>
      <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end notification">
        <div class="noti-head">
          <h6 class="d-inline-block m-b-0">Notifications</h6>
          <div class="float-end">
            <a href="javascript:" class="m-r-10">mark as read</a>
            <a href="javascript:">clear all</a>
          </div>
        </div>
        <ul class="noti-body">
          <li class="n-title">
            <p class="m-b-0">NEW</p>
          </li>
          <li class="notification">
            <div class="media">
              <img class="img-radius" src="assets/images/user/avatar-1.jpg" alt="Generic placeholder image" />
              <div class="media-body">
                <p>
                  <strong>John Doe</strong><span class="n-time text-muted"><i class="icon feather icon-clock m-r-10"></i>now</span>
                </p>
                <p>New ticket Added</p>
              </div>
            </div>
          </li>
          <li class="n-title">
            <p class="m-b-0">EARLIER</p>
          </li>
          <li class="notification">
            <div class="media">
              <img class="img-radius" src="assets/images/user/avatar-2.jpg" alt="Generic placeholder image" />
              <div class="media-body">
                <p>
                  <strong>Joseph William</strong><span class="n-time text-muted"><i class="icon feather icon-clock m-r-10"></i>10 min</span>
                </p>
                <p>Prchace New Theme and make payment</p>
              </div>
            </div>
          </li>
          <li class="notification">
            <div class="media">
              <img class="img-radius" src="assets/images/user/avatar-3.jpg" alt="Generic placeholder image" />
              <div class="media-body">
                <p>
                  <strong>Sara Soudein</strong><span class="n-time text-muted"><i class="icon feather icon-clock m-r-10"></i>30 min</span>
                </p>
                <p>currently login</p>
              </div>
            </div>
          </li>
        </ul>
        <div class="noti-footer">
          <a href="javascript:">show all</a>
        </div>
      </div>
    </div>
  </li>
  <li (click)="this.visibleUserList = !this.visibleUserList" role="none" (keypress)="this.visibleUserList = !this.visibleUserList">
    <a href="javascript:" class="displayChatbox"><i class="icon feather icon-mail"></i></a>
  </li>
  <li>
    <div class="dropdown drp-user" ngbDropdown placement="auto">
      <a href="javascript:" ngbDropdownToggle data-toggle="dropdown">
        <i class="icon feather icon-settings"></i>
      </a>
      <div class="dropdown-menu dropdown-menu-end profile-notification" ngbDropdownMenu>
        <div class="pro-head">
          <img src="assets/images/user/avatar-1.jpg" class="img-radius" alt="User-Profile-Image" />
          <span>John Doe</span>
          <a href="javascript:" class="dud-logout" title="Logout" (click)="logout()">
            <i class="feather icon-log-out"></i>
          </a>
        </div>
        <ul class="pro-body">
          <li>
            <a href="javascript:" class="dropdown-item"><i class="feather icon-settings"></i> Settings</a>
          </li>
          <li>
            <a href="javascript:" class="dropdown-item"><i class="feather icon-user"></i> Profile</a>
          </li>
          <li>
            <a href="javascript:" class="dropdown-item"><i class="feather icon-mail"></i> My Messages</a>
          </li>
          <li>
            <a href="javascript:" class="dropdown-item"><i class="feather icon-lock"></i> Lock Screen</a>
          </li>
        </ul>
      </div>
    </div>
  </li>
</ul>
<section
  class="header-user-list"
  *ngIf="visibleUserList && !this.config['rtl-layout']"
  [ngClass]="{ open: visibleUserList }"
  [@slideInOutLeft]
>
  <app-chat-user-list
    (onChatToggle)="onChatToggle($event)"
    (onChatCollapse)="this.visibleUserList = !this.visibleUserList; this.chatMessage = false"
  ></app-chat-user-list>
</section>

<section class="header-chat" *ngIf="chatMessage && !this.config['rtl-layout']" [ngClass]="{ open: chatMessage }" [@slideInOutLeft]>
  <app-chat-msg (onChatToggle)="this.chatMessage = !this.chatMessage" [friendId]="friendId"></app-chat-msg>
</section>

<section
  class="header-user-list"
  *ngIf="visibleUserList && this.config['rtl-layout']"
  [ngClass]="{ open: visibleUserList }"
  [@slideInOutRight]
>
  <app-chat-user-list
    (onChatToggle)="onChatToggle($event)"
    (onChatCollapse)="this.visibleUserList = !this.visibleUserList; this.chatMessage = false"
  ></app-chat-user-list>
</section>

<section class="header-chat" *ngIf="chatMessage && this.config['rtl-layout']" [ngClass]="{ open: chatMessage }" [@slideInOutRight]>
  <app-chat-msg (onChatToggle)="this.chatMessage = !this.chatMessage" [friendId]="friendId"></app-chat-msg>
</section>-->


<div class="navbar pcoded-header navbar-light navbar-auto-adjust ">
  <ul class="navbar-nav">
    <!--<li>
        <a class="btn themedefault p-1 ps-3 pe-3 mx-1" (click)="common.setClearAllFields(true)">Clear Fields</a></li>-->
    <li style="padding:0px !important" (click)="BusinessList()">
      <div class="" *ngIf="common.headertags == true">
        <h4 [ngClass]="common.headertags == true  ? '':'null'">
          <span [ngClass]="companyName  ? 'companypatch':''">  {{companyName}}</span>
        </h4>
      </div>
    </li>

    <!--<li>
      <div class="">
        <h5 class="btncompany  header-item waves-effect fw-bolder" style="border-right: 1px solid #d8d8d8;"><span class="mx-1 fa fa-solid fa-building"></span>  Andica Limited </h5>
      </div>
    </li>-->
    <li class="pe-0">
      <div class="d-sm-flex d-block pt-2" *ngIf="common.headertags1 == true">
        <div class="">
          <h5 class="mx-2 fw-bolder" style="color: #016973; font-size:15px !important">Accounting Period<span>:</span></h5>
        </div>
        <div class="">
          <h5 style="color: #016973 !important; font-size:15px!important">{{Accountsstart | date :"dd/MM/y"}} - {{accountsEnd | date : "dd/MM/y"}}</h5>
        </div>
      </div>
    </li>
    <li class="pe-1 ps-3"><img src="../../../../../../assets/images/logo-sm.png" width="25" height="25" style="cursor: pointer" class="mb-1" (click)="andicaCentral_navigate()"/></li>
    <li>
      <div class=" drp-user" ngbDropdown placement="auto">
        <a href="javascript:" ngbDropdownToggle data-toggle="dropdown">
          <!--<i class="icon feather icon-settings"></i>-->
          <h4 class="fw-bolder"><span class="" style="border-left: 1px solid #5656563b; padding: 0px 4px;"><i class="icon feather icon-user mx-2" style="border: 1px solid #58585894; border-radius: 50% !important;"></i> </span>{{common.UserName}}</h4>
        </a>
        <div class="dropdown-menu dropdown-menu-end profile-notification" ngbDropdownMenu>
          <div class="pro-head">
            <!--<img src="assets/images/user/avatar-1.jpeg" class="img-radius" alt="User-Profile-Image" />-->
            <span class="ps-2">{{common.UserName}}</span>
            <!--<a href="javascript:" class="dud-logout" title="Logout" (click)="logout()">
              <i class="feather icon-log-out"></i>
            </a>-->
          </div>
          <ul class="pro-body" style="cursor:pointer!important">
            <li>
              <a routerLink="/quick-start" routerLinkActive="active" class="dropdown-item text-dark"><img src="../../../../../../assets/images/Quick-Start-icon.png" />Quick Start</a>
            </li>
            <li>
              <a href="javascript:" class="dropdown-item text-dark" (click)="UserLicense(license)"><img src="../../../../../../assets/images/License-d-icon.ico"> User Licence Details</a>
            </li>
            <li>
              <a class="dropdown-item text-dark" (click)="user($event)"><img src="../../../../../../assets/images/New User.png" /> User Management</a>
            </li>
            <li>
              <a class="dropdown-item text-dark" (click)="helpFileClick($event)"><img src="../../../../../../assets/images/New User.png" /> Help File</a>
            </li>
            <li *ngIf="APPeriodId">
              <a class="dropdown-item text-dark" routerLink="/formstatus" routerLinkActive="active"><img src="../../../../../../assets/images/Status-icon.gif" class="me-1" />Status</a>
            </li>
            <li *ngIf="APPeriodId">
              <a class="dropdown-item text-dark" (click)="Onlnsubmisiion()" routerLinkActive="active"><i class="feather icon-check-square" style="color: #016973;font-size: 22px;margin: 0;"></i> Online Submission</a>
            </li>
            <!--<li>
    <a class="dropdown-item text-dark" routerLink="/fbidetail" routerLinkActive="active"><i class="feather icon-check-square" style="color: #016973;font-size: 22px;margin: 0;"></i> Online Submission</a>
  </li>-->
            <li style="cursor:pointer">
              <a class="dropdown-item text-dark" routerLinkActive="active" (click)="logout()"><i class="feather icon-log-out" style="color: #000000; font-size: 22px; margin: 0;"></i> Logout</a>
            </li>
            <!--<li>
    <a href="javascript:" class="dropdown-item"><i class="feather icon-lock"></i> Lock Screen</a>
  </li>-->
          </ul>
        </div>
      </div>
    </li>
    <!--<li>
      <div class="">
        <h4 style="border-left: 1px solid #5656563b; padding: 1px 10px;">
          <i class="icon feather icon-settings"></i>
        </h4>
      </div>
    </li>-->
  </ul>
</div>
<ng-template #license>
  <form id="Andicaform">
    <div class="modal-content">
      <div class="modal-header">
        <!--<span class="CT600-icon">
          <img src="../../../../assets/images/andica-sm.png" />
        </span>
        <img class="cus-madal-img-icon" src="{{imgsrc}}" alt="{{imgsrc}}" />
        <h6 class="modal-title" id="exampleModalLabel">Andica Accounting Software</h6>-->
        <div class="row">
          <!--<img src="../../../../assets/images/logo-sm.png" />-->
          <h5 class="d-none"><img src="../../../../../../assets/images/logo-sm.png" style="width: 26px !important; margin-top: -2px; background: #00343926; padding: 4px; border-radius: 5px; " class="me-2 d-none"><span class="text-dark fw-bold fs-6 d-none">Andica Accounts Production Software</span></h5>
          <!--<span class="text-left" style="margin-top: -10px;">Version 2021</span>-->
        </div>
        <button type="button" (click)="Cancel()" class="btn btn-close" data-toggle="collapse" data-target="#FormName" data-dismiss="modal" aria-label="Close">
        
        </button>
      </div>

      <div class="modal-body" style=" background-color: #f0f0f0; padding: 0.858rem; padding-top: 1px;">
        <div class="row">
          <div class="col-md-4 col-sm-4 col-12 p-0">
            <img src="../../../../../../assets/images/andica-license-image.png" alt="Andica Property Finance Software" class="img-fluid" style="height: 103%;" />
          </div>
          <div class="col-md-8 col-sm-8 col-12" style=" margin: 0px 0 0 -3px;">
            <div class="row">
              <h5 class="text-black fw-bold mb-1">Andica Accounts Production Software</h5>
              <!--<h5 class="text-black fw-bold mb-1">Andica Accounts Production Software (Version {{common.Version}})</h5>-->
              <!--<h6 class="text-black mb-2 f-14 fw-bold">Accounting Periods upto {{common.TaxYear}} </h6>-->
            </div>
            <div class="row text-dark">
              <div class="col-lg-12" style="font-size:15px !important">
                <span style="font-weight: 600;" class="f-14">This product is licenced for </span><br />
                <span style="font-weight: 600;" class="f-14">Company Name: </span> <span class="f-14">{{common.userCompanyname}}</span><br />
                <span style="font-weight: 600;" class="f-14">Name: </span> <span class="f-14">{{common.UserLicenceName}}</span><br />
                <span style="font-weight: 600;" class="f-14">Email:  </span> <span class="f-14">{{common.emailId}}</span><br />
                <span style="font-weight: 600;" class="f-14">Mobile Number:  </span> <span class="f-14">{{common.mobileNumber}}</span><br />
                <hr />
                <span style="font-weight: 600;" class="f-14">Software is licenced for </span><br />
                <span style="font-weight: 600;" class="f-14">Subscription Type: </span> <span class="f-14">{{common.RegistrationType}}</span><br />
                <span style="font-weight: 600;" class="f-14">Number of Record(s): </span> <span class="f-14">{{common.NumberOfCompanies}}</span><br />
                <span style="font-weight: 600;" class="f-14">Number of User(s): </span> <span class="f-14">{{common.NumberOfUsers}}</span><br />
                <span style="font-weight: 600;" class="f-14">Subscription Date: </span> <span class="f-14">{{common.TUStartDate |date:'dd/MM/yyyy'}}</span><br />
                <span style="font-weight: 600;" class="f-14">Expiry Date: </span> <span class="f-14">{{common.TUEndDate|date:'dd/MM/yyyy'}}</span><br />
                <span style="font-weight: 600;" class="f-14">Business(s) Status: </span> <span class="f-14">{{companycount}} out of {{common.NumberOfCompanies}} Business(s) has been created</span><br />
                <span style="font-weight: 600;" class="f-14">User(s) Status: </span> <span class="f-14">{{UserListcount}} out of {{common.NumberOfUsers}} User(s) has been created</span><br />
                <span style="font-weight: 600;" class="f-14">Submission Status: </span> <span class="f-14"> Live submission for {{common.LiveSubmissionCount}} out of {{common.NumberOfCompanies}} Business return(s) has been submitted successfully.</span><br />
                <hr />
                <b class="text-danger fw-bolder f-14">Warning: </b> <span class="f-14">This Computer program is protected by copyright law and international treaties.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer pt-2 pb-2">
        <button type="button" class="btn btn-success pt-2 pb-2" *ngIf="!common.ShowUpgrade" (click)="Upgrade('Upgrade')">Upgrade</button>
        <button type="button" *ngIf="common.ShowRenew " class="btn btn-primary pt-2 pb-2" (click)="Upgrade('Renew')">Renew</button>
        <button type="button" class="btn btn-danger pt-2 pb-2" (click)="Cancel()" data-toggle="collapse" data-target="#FormName" data-dismiss="modal" aria-label="Close" style="color: #fff; background-color: #f44236; border-color: #f44236;">Close</button>
      </div>
    </div>
  </form>
</ng-template>


